import { XdrIncidentDetailsWebComponent } from './component/XdrIncidentDetailsWebComponent';
export { XdrIncidentDetailsWebComponent };

export interface TranslationsSections {
  generalSectionLabels: GeneralSectionLabels;
  attackInfoSectionLabels: AttackInfoSectionLabels;
  analysisSectionLabels: AnalysisSectionLabels;
  techniquesSectionLabels: TechniquesSectionLabels;
  incidentDetailsTitle: string;
  viewIncidentButton: string;
  viewResponsesButton: string;
}

export interface TechniquesSectionLabels {
  sectionTitle: string;
}

export interface GeneralSectionLabels {
  sectionTitle: string;
  id: string;
  created: string;
  lastUpdated: string;
  company: string;
  severity: string;
}
export interface AnalysisSectionLabels {
  sectionTitle: string;
  status: string;
  assignee: string;
  priority: string;
}

export interface AttackInfoSectionLabels {
  sectionTitle: string;
  actionTaken: string;
  alerts: string;
  entities: string;
  resources?: string;
  correlatedIncidents?: string;
  killChainPhases?: string;
}
